module.exports = __webpack_public_path__ + "img/logo-proAct-dark.46f74c45.svg";